import { ReactNode, useState } from 'react';
import SectionHeader from './SectionHeader';

interface Props {
  /** 섹션 번호 (①, ②, …) — 제목 앞에 항상 붙는다 */
  no: string;
  title: string;
  /** 제목 옆 건수 — 숫자를 넘기면 "총 N건"으로 그린다 */
  count?: number;
  /** 건수 옆 보조 문구 */
  note?: ReactNode;
  /** 헤더 우측, 접기 버튼 왼쪽에 놓을 섹션별 액션 버튼 */
  actions?: ReactNode;
  /** 처음부터 접힌 채로 열지 */
  defaultFolded?: boolean;
  children: ReactNode;
}

/**
 * ①~⑦ 각 영역의 묶음 — 제목줄(파란 제목 + 가로선)과 본문을 한 덩어리로 다룬다.
 * 테두리 있는 상자는 쓰지 않는다(styles.ts의 `.section-box` 주석 참고).
 *
 * 접기 상태를 여기서 들고 있어서 각 섹션은 state를 따로 두지 않아도 된다.
 * 접을 때 DOM을 없애지 않고 감추기만 하는데, 표의 스크롤 위치나 체크 상태처럼
 * 컴포넌트 안에만 있는 값이 접었다 펼 때 날아가지 않게 하기 위함이다.
 */
const SectionBox = ({
  no,
  title,
  count,
  note,
  actions,
  defaultFolded = false,
  children,
}: Props) => {
  const [folded, setFolded] = useState(defaultFolded);

  return (
    <div className={`section-box${folded ? ' folded' : ''}`}>
      <SectionHeader
        no={no}
        title={title}
        count={count}
        note={note}
        folded={folded}
        onToggleFold={() => setFolded((v) => !v)}
      >
        {actions}
      </SectionHeader>
      <div className="section-body" style={{ display: folded ? 'none' : undefined }}>
        {children}
      </div>
    </div>
  );
};

export default SectionBox;
